// ── Sidebar scale factor ───────────────────────────────────────
// 1.0 = original size, 0.75 = 75% of original. Change this single
// value to resize icons, buttons, spacing and sidebar width at once.
export const SIDEBAR_ICON_SCALE = 0.75;
export const TOOL_ICON_SIZE = Math.round(18 * SIDEBAR_ICON_SCALE); // 14  tool icons
export const TOGGLE_ICON_SIZE = Math.round(14 * SIDEBAR_ICON_SCALE); // 11  view-mode toggle icons
export const BTN_HEIGHT = TOOL_ICON_SIZE + 6; // 20  button/cell height
export const GRID_SIDEBAR_WIDTH = TOOL_ICON_SIZE * 2 + 22; // 50  grid sidebar
export const LIST_SIDEBAR_WIDTH = TOOL_ICON_SIZE + 140; // 154 list sidebar
// ────────────────────────────────────────────────────────────────
